exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#hubspot-conversations-inline-iframe {\n  height: calc(var(--vh, 1vh) * 100) !important;\n  height: 100vh;\n  width: 100%;\n  border: 0px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3e33ba39","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/public/HubspotChat.vue
// module id = 2681
// module chunks = 29 31 34 44 46